(function () {
  function store(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function subscribe(form, email) {
    return window
      .fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.dataset.lmdsKlaviyo), {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.lmdsSource || 'Site',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.lmdsKlaviyoList } } }
          }
        })
      })
      .then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
      });
  }

  function copy(text, button) {
    var label = button.textContent;
    var done = function () {
      button.textContent = 'Copié';
      button.classList.add('is-done');
      setTimeout(function () {
        button.textContent = label;
        button.classList.remove('is-done');
      }, 2200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, done);
    } else {
      done();
    }
  }

  function showSuccess(form) {
    var code = (form.dataset.lmdsCode || '').trim();
    store('lmds-nl-subscribed', '1');
    if (code) {
      window.fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
    }

    var box = document.createElement('div');
    box.className = 'lmds-signup-success';
    box.setAttribute('role', 'status');

    var text = document.createElement('p');
    text.className = 'lmds-signup-success__text';
    text.textContent = form.dataset.lmdsSuccess || 'Merci, votre inscription est confirmée.';
    box.appendChild(text);

    if (code) {
      var row = document.createElement('div');
      row.className = 'lmds-signup-success__code';
      var value = document.createElement('span');
      value.className = 'lmds-signup-success__value';
      value.textContent = code;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lmds-signup-success__copy';
      button.textContent = 'Copier';
      button.addEventListener('click', function () {
        copy(code, button);
      });
      row.appendChild(value);
      row.appendChild(button);
      box.appendChild(row);
    }

    form.classList.add('lmds-signup--done');
    form.appendChild(box);
    document.dispatchEvent(new CustomEvent('lmds:subscribed'));
  }

  function fallback(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('form[data-lmds-klaviyo] button');
      if (!button || button.type !== 'submit') return;
      var form = button.form;
      var input = form && form.querySelector('input[type="email"]');
      if (!input || !form.dataset.lmdsKlaviyo || !form.dataset.lmdsKlaviyoList || !window.fetch) return;
      event.preventDefault();
      if (form.dataset.lmdsBusy) return;
      input.value = input.value.trim();
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }
      form.dataset.lmdsBusy = '1';
      button.setAttribute('aria-busy', 'true');
      form.classList.add('lmds-signup--busy');
      subscribe(form, input.value)
        .then(function () {
          showSuccess(form);
        })
        .catch(function () {
          fallback(form);
        })
        .then(function () {
          delete form.dataset.lmdsBusy;
          button.removeAttribute('aria-busy');
          form.classList.remove('lmds-signup--busy');
        });
    },
    true
  );
})();
